export enum NoteType {
    Internal,
    Administrative,
    General,
    Historical,
    Clarification,
    Critical
}